// =====================================================
// UTILIDADES DE AUTENTICACIÓN
// =====================================================

/**
 * Hash simple para contraseñas usando Web Crypto API
 * Solo para frontend - NO es criptográficamente seguro para backend
 */
export const simpleHash = async (text) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

/**
 * Verifica si una contraseña coincide con su hash
 */
export const verifyPassword = async (password, hash) => {
  const passwordHash = await simpleHash(password);
  return passwordHash === hash;
};

/**
 * Gestión de sesión en localStorage
 */
export const SessionManager = {
  setSession: (user) => {
    const sessionData = {
      user,
      timestamp: Date.now(),
      expires: Date.now() + (8 * 60 * 60 * 1000) // 8 horas
    };
    localStorage.setItem('pe_session', JSON.stringify(sessionData));
  },

  getSession: () => {
    try {
      const sessionData = JSON.parse(localStorage.getItem('pe_session'));
      if (!sessionData) return null;
      
      // Verificar si la sesión ha expirado
      if (Date.now() > sessionData.expires) {
        SessionManager.clearSession();
        return null;
      }
      
      return sessionData.user;
    } catch {
      return null;
    }
  },

  clearSession: () => {
    localStorage.removeItem('pe_session');
  },

  extendSession: () => {
    const sessionData = JSON.parse(localStorage.getItem('pe_session'));
    if (sessionData) {
      sessionData.expires = Date.now() + (8 * 60 * 60 * 1000);
      localStorage.setItem('pe_session', JSON.stringify(sessionData));
    }
  }
};

/**
 * Generador de hash para configurar nuevas contraseñas
 * Usar en consola del navegador: generatePasswordHash('tu_contraseña')
 */
export const generatePasswordHash = async (password) => {
  const hash = await simpleHash(password);
  console.log(`Password: ${password}`);
  console.log(`Hash: ${hash}`);
  return hash;
};

// Hacer disponible globalmente para desarrollo
if (process.env.NODE_ENV === 'development') {
  window.generatePasswordHash = generatePasswordHash;
}